import React from 'react';
import { StyledButtonRow } from './styles';
import { ButtonRowProps } from './types';

export type { ButtonRowProps } from './types';

export const ButtonRow: React.FC<ButtonRowProps> = ({ children, align = 'end', ariaLabel = 'Actions' }) => (
  <StyledButtonRow align={align} role="group" aria-label={ariaLabel}>
    {children}
  </StyledButtonRow>
);
